<template>
  <div class="advertisements">
    <div class="advertisements__header px-5 pt-4 pb-2">
      <a-row type="flex" justify="space-between" align="center">
        <h2>Tiktoks Table</h2>
        <router-link to="/tiktoks/new">
          <a-button type="primary">Create Tiktok</a-button>
        </router-link>
      </a-row>
      <Filters />
    </div>
    <a-row>
      <Table :columns="columns" :data="tiktoks">
        <template v-slot:id="scope">
          <Icon name="Document" class="advertisement__icon" />
          <p>{{ scope.item.id }}</p>
        </template>
        <template v-slot:username="scope">
          {{ scope.item.username }}
        </template>
        <template v-slot:is_ad="scope">
          {{ scope.item.is_ad }}
        </template>
        <template v-slot:new="scope">
          {{ scope.item.new }}
        </template>
        <template v-slot:is_free="scope">
          {{ scope.item.is_free }}
        </template>
        <template v-slot:industry="scope">
          <div class="advertisement__tags">
            <a-tag
              color="green"
              v-for="objective in scope.item.industry"
              :key="objective"
            >
              {{ objective }}
            </a-tag>
          </div>
        </template>

        <template v-slot:created_time="scope">
          <p>{{ formatDate(scope.item.created_time) }}</p>
        </template>
        <template v-slot:actions="scope">
          <router-link :to="`/tiktoks/edit/${scope.item.id}`">
            <a-button>Edit</a-button>
          </router-link>
        </template>
        <template v-slot:popover="scope">
          <div class="popover">
            <div class="popover__header" v-if="scope.item.download_link">
              <a
                :href="scope.item.download_link"
                target="_blank"
                class="popover__url"
                :id="`url${scope.item.id}`"
                >{{ scope.item.download_link }}</a
              >
              <button
                class="btn_copy"
                :data-clipboard-target="`#url${scope.item.id}`"
              >
                Copy URL
              </button>
            </div>
            <div class="popover__body">
              <template v-if="scope.item.download_link">
                <p>Preview</p>
                <video
                  width="240"
                  height="240"
                  controls
                  v-if="scope.item.download_link.includes('.mp4')"
                >
                  <source :src="scope.item.download_link" type="video/mp4" />
                </video>
              </template>
            </div>
          </div>
        </template>
      </Table>
    </a-row>
  </div>
</template>

<script>
import { onMounted, onUnmounted, computed } from "vue";
import { useStore } from "vuex";
import moment from "moment";
import Clipboard from "clipboard";
import Table from "@/components/Table/index";
import Icon from "@/components/UI/Icon";
import Filters from "@/components/TiktokFilters";

export default {
  components: { Table, Icon, Filters },
  data() {
    return {
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
          style: {
            width: "350px",
            flex: "none",
          },
          class: "open_popover",
          slot: true,
        },
        {
          title: "Username",
          dataIndex: "username",
          key: "username",
          slot: true,
          class: "open_popover",
        },
        {
          title: "Is Ad",
          dataIndex: "is_ad",
          key: "is_ad",
          slot: true,
          class: "open_popover",
        },
        {
          title: "New",
          dataIndex: "new",
          key: "new",
          slot: true,
          class: "open_popover",
        },
        {
          title: "Is free",
          dataIndex: "is_free",
          key: "is_free",
          slot: true,
          class: "open_popover",
        },
        {
          title: "Industry",
          dataIndex: "industry",
          key: "industry",
          slot: true,
          style: {
            position: "relative",
          },
        },
        {
          title: "Created time",
          dataIndex: "created_time",
          key: "created_time",
          slot: true,
        },
        {
          title: "Actions",
          dataIndex: "actions",
          key: "actions",
          slot: true,
        },
      ],
    };
  },
  methods: {
    formatDate(value) {
      return moment(value).fromNow();
    },
  },
  setup() {
    const store = useStore();

    onMounted(async () => {
      await store.dispatch("GET_TIKTOKS");
      new Clipboard(".btn_copy");
      window.addEventListener("scroll", onScroll);
    });

    onUnmounted(() => {
      store.commit("SET_PAGE", 0);
      store.commit("SET_TIKTOKS", null);
      window.removeEventListener("scroll", onScroll);
    });

    const tiktoks = computed(() => store.state.tiktoks);

    const onScroll = async () => {
      if (store.state.totalTiktoks > tiktoks.value.length) {
        if (
          document.documentElement.scrollHeight ===
          document.documentElement.scrollTop +
            document.documentElement.offsetHeight
        ) {
          await store.dispatch("GET_TIKTOKS");
        }
      }
    };

    return { tiktoks, onScroll };
  },
};
</script>

<style scoped>
.advertisements {
}
.advertisements__item__media {
  max-width: 200px;
}
.popover {
  padding: 5px 10px;
}
.popover__url {
  display: block;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.popover__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.popover__body {
  display: grid;
  grid-template-columns: 100px auto;
}
.advertisement__tags {
  position: absolute;
  width: 100%;
  height: 100%;
  display: grid;
  grid-auto-flow: column;
  gap: 5px;
  justify-content: start;
  align-items: center;
  overflow: hidden;
  background-color: #fff;
  padding-top: 5px;
}
.advertisement__tags:hover {
  grid-auto-flow: row;
  height: auto;
  overflow: initial;
  flex-wrap: wrap;
  z-index: 20;
  padding: 10px;
  border: 1px solid rgb(214, 214, 214);
  border-radius: 2px;
}
.advertisement__icon {
  width: 20px;
  margin-right: 7px;
}
.advertisement__logo {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  object-fit: contain;
  object-position: left;
  border-radius: 100%;
}
</style>
